import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getUsersRepository from './getUsers.repository';
import { UsersDto } from '../../../models/dtos/users.dto';

type InitialState = {
  loading: boolean;
  data?: UsersDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getUsers = createAsyncThunk('getUsers', async (_, { dispatch }) => {
  return await getUsersRepository();
});

const getUsersSlice = createSlice({
  name: 'getUsers',
  initialState,
  reducers: {
    getUsersReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(getUsers.fulfilled, (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getUsersSlice.reducer;
